import { map } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Select from 'components/Select';
import I18n from 'utils/I18n';

const Dropdown = ({ sizes, selectSize, currentSize }) => {
  const handleChange = e => selectSize(e.target.value);

  return (
    <Select
      id="PdpSizeSelector"
      value={currentSize}
      onChange={handleChange}
      ariaLabel={I18n.localize('pdp.selectSize')}
    >
      {map(sizes, ({ id, value, handle }) => (
        <option value={handle} key={id}>
          {value}
        </option>
      ))}
    </Select>
  );
};

Dropdown.propTypes = {
  sizes: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.number, value: PropTypes.string, available: PropTypes.bool })
  ).isRequired,
  selectSize: PropTypes.func.isRequired,
  currentSize: PropTypes.string.isRequired,
};

Dropdown.defaultProps = {};

export default Dropdown;
